import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const rows = [{
    sin: 'Publicás cuando te acordás sin calendario ni sistema',
    costo: 'Semanas enteras sin presencia — el algoritmo te ignora y tus seguidores te olvidan'
  }, {
    sin: 'Improvisás cada caption mirando la pantalla en blanco',
    costo: '20-40 minutos por post de energía mental gastada — y muchas veces terminás no publicando nada'
  }, {
    sin: 'Respondés los mensajes de WhatsApp sin scripts',
    costo: 'Ventas perdidas por no saber qué decir cuando el cliente dice "lo pienso"'
  }, {
    sin: 'No hacés seguimiento de quien preguntó y no compró',
    costo: 'El 80% de las ventas están en el seguimiento — y vos lo estás regalando'
  }, {
    sin: 'Diseñás sin sistema visual coherente',
    costo: 'Feed desorganizado que baja el valor percibido de tu producto antes de que lo vean'
  }, {
    sin: 'No tenés rutinas de contenido',
    costo: 'Semanas de caos alternando con semanas sin publicar — el peor patrón para el crecimiento'
  }, {
    sin: 'Cada mes empezás desde cero sin saber qué funcionó',
    costo: 'Nunca sabés qué tipo de contenido convierte y qué no — cada mes repetís los mismos errores'
  }, {
    sin: 'No tenés sistema de organización de clientes',
    costo: 'Clientes que preguntaron y nunca siguieron — dinero que se fue sin que te des cuenta'
  }];
  return <section className="py-20 bg-zinc-900 text-white" data-id="element-46">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-49">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-50">
          <div className="min-w-[600px]" data-id="element-51">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-52">
              <div className="font-bold text-violet-300 uppercase text-sm tracking-wider" data-id="element-53">
                Sin el Mega Pack
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-54">
                Costo real
              </div>
            </div>

            <div className="space-y-2" data-id="element-55">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 bg-black/60 rounded-xl p-4 items-center border border-violet-900/30" data-id="element-56">
                  <div className="text-zinc-100 font-medium" data-id="element-57">{row.sin}</div>
                  <div className="text-red-300 font-medium" data-id="element-58">{row.costo}</div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-violet-400 mt-4 md:hidden" data-id="element-59">
            ← Scroll to see full table →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-violet-600 to-purple-800 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-60">
          <p className="md:text-2xl font-medium text-white mb-4 text-[16px]" data-id="element-61">
            La próxima semana puede encontrarte diferente.
          </p>
          <p className="md:text-4xl font-black text-white text-[20px]" data-id="element-62">
            "La próxima vez que alguien te pregunte por tu producto, vas a saber
            exactamente qué decir y cómo cerrarlo." 🌸🇦🇷
          </p>
        </motion.div>
      </div>
    </section>;
}